module.exports = __webpack_public_path__ + "img/box2Logo.5b918a49.png";